/* TRWS product list filters (collection + search pages).
   Built on Shopify native storefront filtering (Search & Discovery).
   Heartland fields are used as-is; grouping and cleanup happen here:
   - Feel (online_feel3) is grouped into shopper labels.
   - Activity (online_feel_child_2) and Injury (online_injury) hold comma lists;
     each name becomes one option that ORs every stored combination containing it.
   - Injury keeps only the first two names Heartland lists for each shoe. */
(function () {
  'use strict';

  var P = {
    feel: 'filter.p.m.custom.online_feel3',
    activity: 'filter.p.m.custom.online_feel_child_2',
    injury: 'filter.p.m.custom.online_injury',
    width: 'filter.p.m.custom.online_width',
    cat: 'filter.p.m.custom.online_shop_left_hand_filters',
    clothing: 'filter.p.m.custom.online_clothing_type',
    acc: 'filter.p.m.custom.online_child_category',
    med: 'filter.p.m.custom.online_sports_medicine_recovery',
    gender: 'filter.p.m.custom.online_parent_category',
    vendor: 'filter.p.vendor',
    size: 'filter.v.option.size',
    avail: 'filter.v.availability'
  };

  var FEEL = [
    { label: 'Neutral', values: ['Neutral Footwear'], tip: 'Balanced cushion for an efficient stride' },
    { label: 'Max Cushion', values: ['Neutral Plus'], tip: 'The most foam, for long miles and recovery days' },
    { label: 'Stability', values: ['Guidance', 'Light Stability', 'Stability', 'Motion Control'], tip: 'Includes Guidance and Light Stability. Helps if your foot rolls inward' },
    { label: 'Lightweight / Speed', values: ['Lightweight'], tip: 'Lower and lighter for tempo and race days' },
    { label: 'Carbon Race', values: ['Carbon Fiber'], tip: 'Plated super shoes built for racing' },
    { label: 'Trail', values: ['Trail'], tip: 'Lugged outsoles for dirt, gravel and rock' },
    { label: 'Court', values: ['Court Shoe'], tip: 'Pickleball and court shoes' }
  ];

  var ACTIVITY_ORDER = ['Walking', 'Working', 'Short Runs (Under 10K)', 'Long Runs', 'Ultra Distance', 'Speed Work', 'Trail', 'Gym', 'Track & XC Spikes', 'Pickleball', 'Recovery & Casual'];
  var ACTIVITY_NAMES = {
    'walking': 'Walking',
    'working': 'Working',
    'short distance running (<10k)': 'Short Runs (Under 10K)',
    'long distance running': 'Long Runs',
    'ultra distance running': 'Ultra Distance',
    'speed': 'Speed Work',
    'trail': 'Trail',
    'gym shoe': 'Gym',
    'spikes': 'Track & XC Spikes',
    'pickleball': 'Pickleball',
    'recovery': 'Recovery & Casual',
    'casual': 'Recovery & Casual'
  };
  var INJURY_NAMES = {
    'achiles tendinitis': 'Achilles Tendinitis',
    'achilles tendinitis': 'Achilles Tendinitis',
    'achilles tendonitis': 'Achilles Tendinitis',
    'plantar fascitis': 'Plantar Fasciitis',
    'plantar fasciitis': 'Plantar Fasciitis',
    'it band': 'IT Band',
    "morton's neuroma": "Morton's Neuroma",
    'numb feet': 'Numb Feet',
    'knee pain': 'Knee Pain',
    'back pain': 'Back Pain',
    'shin splints': 'Shin Splints',
    'flat feet': 'Flat Feet',
    'bunion': 'Bunions',
    'bunions': 'Bunions',
    'stress fracture': 'Stress Fracture',
    'general foot pain': 'General Foot Pain'
  };
  var WIDTH_ORDER = ['Narrow', 'Standard', 'Wide', 'Xtra Wide'];
  var WIDTH_LABEL = { 'Xtra Wide': 'Extra Wide' };
  var CAT_LABEL = { 'Sports Medicine & Recovery': 'Sports Medicine & Recovery' };
  var CATEGORIES = ['Footwear', 'Clothing', 'Accessories', 'Sports Medicine & Recovery'];
  var GENDERED = { 'Footwear': true, 'Clothing': true };
  // Color families. Products are matched on the server (snippets/trws-color-families.liquid).
  var COLORS = [
    { id: 'black', label: 'Black', hex: '#1d1d1f' },
    { id: 'white', label: 'White', hex: '#ffffff' },
    { id: 'gray', label: 'Gray', hex: '#9aa3ab' },
    { id: 'blue', label: 'Blue', hex: '#2f6fd6' },
    { id: 'green', label: 'Green', hex: '#3f9b4f' },
    { id: 'red', label: 'Red', hex: '#d23b3b' },
    { id: 'pink', label: 'Pink', hex: '#ef7fb0' },
    { id: 'purple', label: 'Purple', hex: '#8a57c8' },
    { id: 'orange', label: 'Orange', hex: '#f28a2e' },
    { id: 'yellow', label: 'Yellow', hex: '#f3d03e' },
    { id: 'brown', label: 'Brown', hex: '#7a5233' },
    { id: 'beige', label: 'Beige & Tan', hex: '#d9c7a7' }
  ];
  function colorLabel(id) { for (var i = 0; i < COLORS.length; i++) if (COLORS[i].id === id) return COLORS[i].label; return id; }
  function pickedColors() { return currentParams().getAll('color'); }
  // Brands show with the first letter of each word capitalized (Hoka, Asics, New Balance),
  // except true acronyms.
  var BRAND_LABEL = { 'ON RUNNING': 'On', 'TRWS': 'TRWS', 'CEP': 'CEP', 'BPN': 'BPN', 'GU': 'GU', 'OS1ST': 'OS1st', 'K-SWISS': 'K-Swiss' };
  function brandLabel(l) { var k = String(l).toUpperCase(); return BRAND_LABEL[k] || titleCase(String(l)); }
  // Every filter label: first letter of each word capitalized, never all caps.
  function nice(l) {
    var t = String(l);
    if (t === t.toUpperCase() || t === t.toLowerCase()) t = titleCase(t);
    return t.replace(/(^|[ (/-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }).replace(/(^|[^A-Za-z])(Xc|It)(?![A-Za-z])/g, function (m, a, b) { return a + b.toUpperCase(); }).replace(/(^|[^A-Za-z0-9])10k(?![A-Za-z0-9])/gi, '$110K');
  }

  // In-store pickup. Shopify location ids for the three stores with local pickup.
  var STORES = [
    { id: 'mission', label: 'Mission', loc: 'gid://shopify/Location/69722472507' },
    { id: 'barry', label: 'Barry Road', loc: 'gid://shopify/Location/69722800187' },
    { id: 'lees', label: "Lee's Summit", loc: 'gid://shopify/Location/69722832955' }
  ];
  var SF_TOKEN = 'da11ae549267d55ed1e51eeab82f921e';
  function pickedStores() { return currentParams().getAll('store'); }
  var KEEP_PARAMS = ['q', 'type', 'sort_by', 'stock', 'ko', 'options[prefix]', 'options[fields]', 'view', 'color', 'store'];
  var LETTER_SIZES = ['XXS', 'XS', 'S', 'SMALL', 'M', 'MEDIUM', 'L', 'LARGE', 'XL', 'XXL', '2XL', '3XL'];

  var saleMode, isSearch;
  var root, sectionId, filtersEl, chipsEl, resultsEl, data, controller, lastGroups = [];
  var openGroups = {};

  function $(sel, el) { return (el || document).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function titleCase(s) {
    return s.toLowerCase().replace(/(^|[ (/-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  // Shopify hands filter values over HTML-escaped (&lt;, &#39;). Decode once.
  var decoder = document.createElement('textarea');
  function dec(s) { decoder.innerHTML = s == null ? '' : String(s); return decoder.value; }

  function readData() {
    var el = document.getElementById('TrwsPlpData');
    try { data = JSON.parse(el.textContent); } catch (e) { data = { filters: [], count: 0 }; }
    if (!data || typeof data !== 'object') data = { count: 0 };
    if (!Array.isArray(data.filters)) data.filters = [];
    if (data.terms) data.terms = dec(data.terms);
    (data.filters || []).forEach(function (f) {
      f.label = dec(f.label);
      (f.values || []).forEach(function (v) { v.v = dec(v.v); v.l = dec(v.l); });
    });
  }

  function findFilter(param) {
    for (var i = 0; i < data.filters.length; i++) if (data.filters[i].param === param) return data.filters[i];
    return null;
  }

  /* ---------- Option builders ---------- */

  function plainOptions(f, labelFn) {
    return (f.values || []).map(function (v) {
      return { label: nice(labelFn ? labelFn(v.l) : v.l), values: [v.v], count: v.c, active: v.a };
    });
  }

  function groupedOptions(f, groups) {
    var byVal = {};
    (f.values || []).forEach(function (v) { byVal[v.v] = v; });
    return groups.map(function (g) {
      var count = 0, allActive = true, values = [];
      g.values.forEach(function (val) {
        var v = byVal[val];
        if (v) { count += v.c; allActive = allActive && v.a; values.push(val); }
      });
      return { label: g.label, tip: g.tip, values: values, count: count, active: values.length > 0 && allActive };
    }).filter(function (o) { return o.values.length; });
  }

  // Split comma-joined Heartland values into one option per name.
  function splitOptions(f, mapNames, limit, order) {
    var map = {};
    (f.values || []).forEach(function (v) {
      var names = String(v.v).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (limit) names = names.slice(0, limit);
      var seen = {};
      names.forEach(function (raw) {
        var key = raw.trim().toLowerCase();
        var label = nice(mapNames[key] || titleCase(raw.trim()));
        if (seen[label]) return;
        seen[label] = true;
        if (!map[label]) map[label] = { label: label, values: [], count: 0, active: true };
        map[label].values.push(v.v);
        map[label].count += v.c;
        map[label].active = map[label].active && v.a;
      });
    });
    var list = Object.keys(map).map(function (k) { return map[k]; });
    if (order) {
      list.sort(function (a, b) {
        var ia = order.indexOf(a.label), ib = order.indexOf(b.label);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.label.localeCompare(b.label);
      });
    } else {
      list.sort(function (a, b) { return a.label.localeCompare(b.label); });
    }
    return list;
  }

  /* ---------- Context: which category are we in? ---------- */

  function context() {
    var f = findFilter(P.cat);
    if (!f) return 'mixed';
    var active = f.values.filter(function (v) { return v.a; });
    if (active.length === 1) return active[0].v;
    if (active.length > 1) return 'mixed';
    var present = f.values.filter(function (v) { return v.c > 0; });
    return present.length === 1 ? present[0].v : 'mixed';
  }

  function buildGroups() {
    var ctx = context();
    var groups = [];
    var f;

    if (storeApi === true) {
      var sp = pickedStores();
      groups.push({ id: 'store', title: 'Pick Up In Store', layout: 'pills', stores: true, note: 'Show only what is on the shelf at your store, in your size.', options: STORES.map(function (st) { return { label: st.label, store: st.id, active: sp.indexOf(st.id) > -1, count: 1 }; }), open: true });
    }

    f = findFilter(P.cat);
    if (f) {
      var present = f.values.filter(function (v) { return v.c > 0 || v.a; });
      if (present.length > 1 || f.values.some(function (v) { return v.a; })) {
        groups.push({ id: 'cat', title: 'Shop', param: P.cat, options: plainOptions(f, function (l) { return CAT_LABEL[l] || l; }), open: true });
      }
    }

    // Gender (Online Gender in Search & Discovery). Only shown when results mix genders.
    f = ctx === 'Accessories' || ctx === 'Sports Medicine & Recovery' ? null : findFilter(P.gender);
    if (f) {
      var genders = f.values.filter(function (v) { return v.c > 0 || v.a; });
      if (genders.length > 1 || f.values.some(function (v) { return v.a; })) {
        groups.push({ id: 'gender', title: 'Gender', param: P.gender, layout: 'pills', options: plainOptions(f), open: true });
      }
    }

    if (ctx === 'Footwear') {
      f = findFilter(P.size);
      if (f) {
        // Shoe sizes 5 to 15 (4 and 4.5 dropped, 14 and 15 for our big-footed runners).
        var shoe = f.values.filter(function (v) { return /^[0-9]{1,2}([.]5)?$/.test(v.v) && parseFloat(v.v) >= 5 && parseFloat(v.v) <= 15; })
          .sort(function (a, b) { return parseFloat(a.v) - parseFloat(b.v); });
        if (shoe.length) groups.push({ id: 'size', title: 'Size', param: P.size, layout: 'grid', options: plainOptions({ values: shoe }), open: true });
      }
      f = findFilter(P.width);
      if (f) {
        var w = plainOptions(f, function (l) { return WIDTH_LABEL[l] || l; });
        w.sort(function (a, b) { return WIDTH_ORDER.indexOf(a.values[0]) - WIDTH_ORDER.indexOf(b.values[0]); });
        groups.push({ id: 'width', title: 'Width', param: P.width, layout: 'pills', options: w, open: true });
      }
      f = findFilter(P.feel);
      if (f) groups.push({ id: 'feel', title: 'Support & Cushion', param: P.feel, options: groupedOptions(f, FEEL), open: true, pick: true });
      f = findFilter(P.activity);
      if (f) groups.push({ id: 'activity', title: 'Activity', param: P.activity, options: splitOptions(f, ACTIVITY_NAMES, 0, ACTIVITY_ORDER), open: false, pick: true });
    }

    if (ctx === 'Clothing') {
      f = findFilter(P.clothing);
      if (f) groups.push({ id: 'clothing', title: 'Type', param: P.clothing, options: plainOptions(f, titleCase), open: true });
      f = findFilter(P.size);
      if (f) {
        var letters = f.values.filter(function (v) { return LETTER_SIZES.indexOf(String(v.v).toUpperCase()) > -1; })
          .sort(function (a, b) { return LETTER_SIZES.indexOf(String(a.v).toUpperCase()) - LETTER_SIZES.indexOf(String(b.v).toUpperCase()); });
        if (letters.length) groups.push({ id: 'size', title: 'Size', param: P.size, layout: 'pills', options: plainOptions({ values: letters }), open: true });
      }
    }

    if (ctx === 'Accessories') {
      f = findFilter(P.acc);
      if (f) groups.push({ id: 'acc', title: 'Type', param: P.acc, options: plainOptions(f), open: true });
    }

    if (ctx === 'Sports Medicine & Recovery') {
      f = findFilter(P.med);
      if (f) groups.push({ id: 'med', title: 'Type', param: P.med, options: plainOptions(f), open: true });
    }

    if (ctx !== 'Sports Medicine & Recovery') {
      var picked = pickedColors();
      groups.push({ id: 'color', title: 'Color', colors: COLORS.map(function (c) { return { id: c.id, label: c.label, hex: c.hex, active: picked.indexOf(c.id) > -1 }; }), open: picked.length > 0 || ctx === 'Footwear' || ctx === 'Clothing' });
    }

    f = findFilter(P.vendor);
    if (f) groups.push({ id: 'brand', title: 'Brand', param: P.vendor, options: plainOptions(f, brandLabel), open: ctx !== 'Footwear', popular: 6 });

    if (ctx === 'Footwear') {
      f = findFilter(P.injury);
      if (f) groups.push({ id: 'injury', title: 'Foot or Leg Pain', param: P.injury, options: splitOptions(f, INJURY_NAMES, 2), open: false, pick: true, note: 'Shoes our fit team recommends most for each issue.' });
    }

    data.filters.forEach(function (pf) {
      if (pf.type === 'price_range') groups.push({ id: 'price', title: 'Price', price: pf, open: false });
    });

    // Single-category pages (a collection like Women's Footwear): a quick link to the matching
    // footwear or clothing page, keeping the gender. Shown first so it is easy to reach.
    var catPicked = (findFilter(P.cat) || { values: [] }).values.some(function (v) { return v.a; });
    if (!isSearch && ctx !== 'mixed' && !catPicked) {
      var gf = findFilter(P.gender);
      var oneGender = gf ? gf.values.filter(function (v) { return v.c > 0; }) : [];
      var gender = oneGender.length === 1 ? oneGender[0].v : '';
      var links = CATEGORIES.filter(function (c) { return c !== ctx && GENDERED[c] && GENDERED[ctx]; }).map(function (c) {
        var q = new URLSearchParams();
        q.set('filter.v.availability', '1');
        q.set('sort_by', 'best-selling');
        q.set(P.cat, c);
        if (gender && GENDERED[c]) q.set(P.gender, gender);
        return { label: (gender && GENDERED[c] ? gender + ' ' : '') + (CAT_LABEL[c] || c), href: '/collections/all?' + q.toString() };
      });
      if (links.length) groups.unshift({ id: 'more', title: 'Shop More', links: links, open: true });
    }

    // Grouped and split options share stored values, so which option the shopper picked
    // is kept in the URL (pick.<group>=<label>). Without it (old or shared links), an
    // option counts as active when all of its values are active.
    var params = currentParams();
    groups.forEach(function (g) {
      if (!g.pick) return;
      var picks = params.getAll('pick.' + g.id);
      if (picks.length) g.options.forEach(function (o) { o.active = picks.indexOf(o.label) > -1; });
    });
    groups.forEach(function (g) {
      if (g.options) g.options = g.options.filter(function (o) { return o.count > 0 || o.active; });
    });
    lastGroups = groups;
    return groups.filter(function (g) { return g.price || g.links || g.colors || (g.options && g.options.length); });
  }

  /* ---------- Render ---------- */

  function toggleRow(id, label, checked, sub) {
    return '<label class="trws-toggle"><input type="checkbox" data-toggle="' + id + '"' + (checked ? ' checked' : '') + '>' +
      '<span class="trws-toggle__track" aria-hidden="true"></span><span class="trws-toggle__label">' + esc(label) +
      (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span></label>';
  }

  function optRow(g, o, hidden) {
    var disabled = o.count === 0 && !o.active;
    return '<li' + (hidden ? ' hidden data-more' : '') + '><label class="trws-opt' + (disabled ? ' is-disabled' : '') + '">' +
      '<input type="checkbox" data-param="' + g.param + '" data-values="' + esc(JSON.stringify(o.values)) + '"' + (g.pick ? ' data-pick="' + g.id + '" data-label="' + esc(o.label) + '"' : '') + (o.active ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
      '<span class="trws-opt__text"><span class="trws-opt__label">' + esc(o.label) + '</span>' + (o.tip ? '<small>' + esc(o.tip) + '</small>' : '') + '</span>' +
      '</label></li>';
  }

  /* Long brand lists (search, All products, accessories): the brands with the most
     products in the current results go first, chosen live from the counts, so the
     names shoppers know rise to the top on every page with no upkeep. Everything else
     sits behind "All brands A to Z" with a find box and letter headings. */
  var brandsOpen = false;
  function brandListHTML(g) {
    var byCount = g.options.slice().sort(function (a, b) { return b.count - a.count || a.label.localeCompare(b.label); });
    var top = byCount.filter(function (o) { return o.active; });
    byCount.forEach(function (o) { if (top.length < g.popular && top.indexOf(o) < 0) top.push(o); });
    var rest = g.options.filter(function (o) { return top.indexOf(o) < 0; })
      .sort(function (a, b) { return a.label.localeCompare(b.label); });
    var html = '<p class="trws-brands__h">Most popular here</p><ul class="trws-opts">';
    top.forEach(function (o) { html += optRow(g, o); });
    html += '</ul>';
    if (!rest.length) return html;
    html += '<button type="button" class="trws-f__more" data-brands-toggle aria-expanded="' + brandsOpen + '">' +
      (brandsOpen ? 'Hide other brands' : 'More brands A to Z (' + rest.length + ')') + '</button>';
    html += '<div class="trws-brands__all"' + (brandsOpen ? '' : ' hidden') + '>' +
      '<input type="search" class="trws-brands__find" data-brand-find placeholder="Find a brand" aria-label="Find a brand" autocomplete="off">' +
      '<ul class="trws-opts trws-brands__list">';
    var letter = '';
    rest.forEach(function (o) {
      var first = o.label.charAt(0).toUpperCase();
      if (!/[A-Z]/.test(first)) first = '#';
      if (first !== letter) { letter = first; html += '<li class="trws-brands__letter" data-letter>' + letter + '</li>'; }
      html += optRow(g, o).replace('<li', '<li data-brand="' + esc(o.label.toLowerCase()) + '"');
    });
    html += '</ul><p class="trws-brands__none" hidden>No brand by that name here.</p></div>';
    return html;
  }

  function findBrand(input) {
    var q = input.value.trim().toLowerCase();
    var box = input.closest('.trws-brands__all');
    var any = false, letterEl = null, letterHas = false;
    box.querySelectorAll('.trws-brands__list > li').forEach(function (li) {
      if (li.hasAttribute('data-letter')) {
        if (letterEl) letterEl.hidden = !letterHas || !!q;
        letterEl = li; letterHas = false; return;
      }
      var show = !q || li.getAttribute('data-brand').indexOf(q) > -1;
      li.hidden = !show;
      if (show) { any = true; letterHas = true; }
    });
    if (letterEl) letterEl.hidden = !letterHas || !!q;
    box.querySelector('.trws-brands__none').hidden = any;
  }

  // Never let one bad value leave the sidebar empty: log it and still show the count.
  function renderFilters() {
    try { drawFilters(); } catch (e) {
      if (window.console) console.error('[trws-plp] filters failed to render', e);
      try { updateCounts(); } catch (e2) {}
    }
  }

  function drawFilters() {
    var groups = buildGroups();
    var html = '';

    // Out-of-stock items are always hidden (the section adds filter.v.availability=1).
    if (!isSearch) html += '<div class="trws-f__toggles">' + toggleRow('sale', 'Sale Only', saleMode) + '</div>';

    groups.forEach(function (g) {
      var isOpen = openGroups[g.id] != null ? openGroups[g.id] : (g.open || (g.options && g.options.some(function (o) { return o.active; })));
      if (g.links) isOpen = openGroups[g.id] != null ? openGroups[g.id] : true;
      var activeCount = g.options ? g.options.filter(function (o) { return o.active; }).length : (g.colors ? g.colors.filter(function (c) { return c.active; }).length : (g.price && (g.price.min != null || g.price.max != null) ? 1 : 0));
      html += '<details class="trws-f" data-group="' + g.id + '"' + (isOpen ? ' open' : '') + '>';
      html += '<summary class="trws-f__head"><span>' + esc(g.title) + '</span>' + (activeCount ? '<span class="trws-f__badge">' + activeCount + '</span>' : '') + '</summary>';
      html += '<div class="trws-f__body">';
      if (g.note) html += '<p class="trws-f__note">' + esc(g.note) + '</p>';
      if (g.price) {
        var max = Math.ceil((g.price.range_max || 0) / 100);
        var lo = g.price.min != null ? Math.floor(g.price.min / 100) : '';
        var hi = g.price.max != null ? Math.ceil(g.price.max / 100) : '';
        html += '<div class="trws-price"><label><span>Min</span><input type="number" inputmode="numeric" min="0" max="' + max + '" placeholder="$0" value="' + lo + '" data-price="min"></label>' +
          '<span class="trws-price__sep">to</span><label><span>Max</span><input type="number" inputmode="numeric" min="0" max="' + max + '" placeholder="$' + max + '" value="' + hi + '" data-price="max"></label>' +
          '<button type="button" class="trws-price__go" data-price-go>Go</button></div>';
      } else if (g.colors) {
        html += '<ul class="trws-swatches">' + g.colors.map(function (c) {
          return '<li><label class="trws-swatch' + (c.active ? ' is-active' : '') + '">' +
            '<input type="checkbox" class="visually-hidden" data-color="' + c.id + '"' + (c.active ? ' checked' : '') + '>' +
            '<span class="trws-swatch__dot trws-swatch__dot--' + c.id + '" style="background:' + c.hex + '" aria-hidden="true"></span>' +
            '<span class="trws-swatch__name">' + esc(c.label) + '</span></label></li>';
        }).join('') + '</ul>';
      } else if (g.links) {
        html += '<ul class="trws-links">' + g.links.map(function (l) {
          return '<li><a href="' + esc(l.href) + '">' + esc(l.label) + '</a></li>';
        }).join('') + '</ul>';
      } else if (g.popular && g.options.length > 10) {
        html += brandListHTML(g);
      } else {
        var cls = g.layout === 'grid' ? 'trws-opts trws-opts--grid' : (g.layout === 'pills' ? 'trws-opts trws-opts--pills' : 'trws-opts');
        html += '<ul class="' + cls + '">';
        g.options.forEach(function (o, i) {
          var hidden = g.truncate && i >= g.truncate && !o.active;
          var payload = esc(JSON.stringify(o.values));
          var disabled = o.count === 0 && !o.active;
          if (g.stores) {
            html += '<li><label class="trws-chipopt' + (o.active ? ' is-active' : '') + '">' +
              '<input type="checkbox" class="visually-hidden" data-store="' + o.store + '"' + (o.active ? ' checked' : '') + '>' +
              '<span>' + esc(o.label) + '</span></label></li>';
          } else if (g.layout === 'grid' || g.layout === 'pills') {
            html += '<li' + (hidden ? ' hidden data-more' : '') + '><label class="trws-chipopt' + (o.active ? ' is-active' : '') + (disabled ? ' is-disabled' : '') + '">' +
              '<input type="checkbox" class="visually-hidden" data-param="' + g.param + '" data-values="' + payload + '"' + (o.active ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
              '<span>' + esc(o.label) + '</span></label></li>';
          } else {
            html += optRow(g, o, hidden);
          }
        });
        html += '</ul>';
        if (g.truncate && g.options.length > g.truncate) {
          html += '<button type="button" class="trws-f__more" data-more-btn>Show all ' + g.options.length + '</button>';
        }
      }
      html += '</div></details>';
    });

    filtersEl.innerHTML = html;
    renderChips(groups);
    updateCounts();
  }

  function renderChips(groups) {
    var chips = [];
    groups.forEach(function (g) {
      if (g.options && !g.stores) {
        g.options.forEach(function (o) {
          if (o.active) chips.push({ label: (g.id === 'size' ? 'Size ' : '') + o.label, param: g.param, values: o.values, pick: g.pick ? g.id : null, optLabel: o.label });
        });
      }
      if (g.price && (g.price.min != null || g.price.max != null)) {
        var lo = g.price.min != null ? '$' + Math.floor(g.price.min / 100) : '$0';
        var hi = g.price.max != null ? '$' + Math.ceil(g.price.max / 100) : 'up';
        chips.push({ label: lo + ' to ' + hi, price: true });
      }
    });
    pickedColors().forEach(function (id) { chips.push({ label: colorLabel(id), color: id }); });
    if (storeApi) pickedStores().forEach(function (id) { var st = STORES.filter(function (x) { return x.id === id; })[0]; if (st) chips.push({ label: 'At ' + st.label, store: id }); });
    if (saleMode) chips.push({ label: 'On sale', toggle: 'sale' });
    if (!chips.length) { chipsEl.innerHTML = ''; chipsEl.hidden = true; return; }
    chipsEl.hidden = false;
    chipsEl.innerHTML = '<ul class="trws-chips">' + chips.map(function (c) {
      var attrs = c.store ? 'data-chip-store="' + c.store + '"' : c.color ? 'data-chip-color="' + c.color + '"' : c.price ? 'data-chip-price' : (c.toggle ? 'data-chip-toggle="' + c.toggle + '"' : (c.pick ? 'data-chip-pick="' + c.pick + '" data-label="' + esc(c.optLabel) + '"' : 'data-param="' + c.param + '" data-values="' + esc(JSON.stringify(c.values)) + '"'));
      return '<li><button type="button" class="trws-chip" ' + attrs + ' aria-label="Remove ' + esc(c.label) + '">' + esc(c.label) + '<span aria-hidden="true">&times;</span></button></li>';
    }).join('') + '<li><button type="button" class="trws-chips__clear" data-clear-all>Clear all</button></li></ul>';
  }

  function updateCounts() {
    var n = data.count || 0;
    var label = n === 1 ? '1 product' : n.toLocaleString() + ' products';
    if (data.terms) label = (n === 1 ? '1 result' : n.toLocaleString() + ' results') + ' for “' + data.terms + '”';
    if (data.scan) {
      label = n.toLocaleString() + (data.more ? '+' : '') + (n === 1 && !data.more ? ' product' : ' products') + (data.sale ? ' on sale' : '');
      if (data.terms) label += ' for “' + data.terms + '”';
    }
    if (storeOn()) {
      var vis = visibleCards();
      var names = pickedStores().map(function (id) { var st = STORES.filter(function (x) { return x.id === id; })[0]; return st ? st.label : id; });
      var moreLeft = !!resultsEl.querySelector('[data-load-more]');
      label = vis + (moreLeft ? '+' : '') + (vis === 1 && !moreLeft ? ' product' : ' products') + ' at ' + names.join(' or ');
    }
    var t = root.querySelector('[data-trws-results-text]');
    if (t) t.textContent = label;
    root.querySelectorAll('[data-trws-results]').forEach(function (el) { el.textContent = n.toLocaleString(); });
    var active = chipsEl.querySelectorAll('.trws-chip').length;
    root.querySelectorAll('[data-trws-count-badge]').forEach(function (el) { el.textContent = active ? '(' + active + ')' : ''; });
    if (data.sort_by) root.querySelectorAll('[data-trws-sort]').forEach(function (sel) { sel.value = data.sort_by; });
  }

  /* ---------- URL state ---------- */

  function currentParams() { return new URLSearchParams(location.search); }

  function baseParams(params) {
    var out = new URLSearchParams();
    params.forEach(function (v, k) {
      if (KEEP_PARAMS.indexOf(k) > -1 || k.indexOf('options[') === 0 || k.indexOf('pick.') === 0) out.append(k, v);
    });
    return out;
  }

  function selectedMap(params) {
    var map = {};
    params.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) { (map[k] = map[k] || []).push(v); }
    });
    return map;
  }

  function toUrl(map, base) {
    var p = base || baseParams(currentParams());
    Object.keys(map).forEach(function (k) {
      var seen = {};
      map[k].forEach(function (v) { if (!seen[v]) { seen[v] = true; p.append(k, v); } });
    });
    var qs = p.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  // One option can stand for several stored values (grouped or split options), and
  // options in the same group can share values. So the URL list for a filter is rebuilt
  // from every checked option in that group, never patched value by value.
  function setValues(param, values, on, fromChip) {
    var params = currentParams();
    var map = selectedMap(params);
    var key = JSON.stringify(values);
    var inputs = Array.prototype.slice.call(filtersEl.querySelectorAll('input[data-param]'))
      .filter(function (i) { return i.getAttribute('data-param') === param; });
    var list;
    if (inputs.length) {
      if (fromChip) inputs.forEach(function (i) { if (i.getAttribute('data-values') === key) i.checked = false; });
      var known = {};
      list = [];
      inputs.forEach(function (i) {
        var vals = JSON.parse(i.getAttribute('data-values'));
        vals.forEach(function (v) { known[v] = true; });
        if (i.checked) list = list.concat(vals);
      });
      // keep values already in the URL that no visible option covers
      (map[param] || []).forEach(function (v) { if (!known[v]) list.push(v); });
    } else {
      list = map[param] || [];
      list = on ? list.concat(values) : list.filter(function (v) { return values.indexOf(v) < 0; });
    }
    if (list.length) map[param] = list; else delete map[param];
    go(toUrl(map));
  }

  function togglePick(groupId, label, on) {
    var g = lastGroups.filter(function (x) { return x.id === groupId; })[0];
    if (!g) return;
    var params = currentParams();
    var base = baseParams(params);
    var picks = g.options.filter(function (o) { return o.active; }).map(function (o) { return o.label; });
    picks = picks.filter(function (l) { return l !== label; });
    if (on) picks.push(label);
    base.delete('pick.' + groupId);
    picks.forEach(function (l) { base.append('pick.' + groupId, l); });
    var map = selectedMap(params);
    var values = [];
    g.options.forEach(function (o) { if (picks.indexOf(o.label) > -1) values = values.concat(o.values); });
    if (values.length) map[g.param] = values; else delete map[g.param];
    go(toUrl(map, base));
  }

  /* Sale: Shopify has no native "on sale" filter (Heartland sets compare-at = price on
     regular items), so Sale only switches the page to the collection.sale template
     (?view=sale). That template keeps every filter and shows only products priced
     below their compare-at price. Full page load, since the template's section differs. */
  function setSale(on) {
    var params = currentParams();
    var map = selectedMap(params);
    var base = baseParams(params);
    if (on) base.set('view', 'sale'); else base.delete('view');
    // Full page load (the sale template's section differs). Show it is working right away.
    root.classList.add('is-loading');
    var t = root.querySelector('[data-trws-results-text]');
    if (t) t.textContent = on ? 'Finding sale items...' : 'Loading...';
    location.href = toUrl(map, base);
  }

  // Color: shopper's picks live in ?color=. The server reads them and returns only matches.
  function setColor(id, on) {
    var params = currentParams();
    var map = selectedMap(params);
    var base = baseParams(params);
    var picks = base.getAll('color').filter(function (c) { return c !== id; });
    if (on) picks.push(id);
    base.delete('color');
    picks.forEach(function (c) { base.append('color', c); });
    go(toUrl(map, base));
  }

  function setStore(id, on) {
    var params = currentParams();
    var map = selectedMap(params);
    var base = baseParams(params);
    var picks = base.getAll('store').filter(function (c) { return c !== id; });
    if (on) picks.push(id);
    base.delete('store');
    picks.forEach(function (c) { base.append('store', c); });
    go(toUrl(map, base));
  }

  function setToggle(id, on) {
    if (id === 'sale') setSale(on);
  }

  function setPrice(min, max) {
    var f = data.filters.filter(function (x) { return x.type === 'price_range'; })[0];
    if (!f) return;
    var params = currentParams();
    var map = selectedMap(params);
    delete map[f.min_param]; delete map[f.max_param];
    if (min !== '' && !isNaN(min)) map[f.min_param] = [String(min)];
    if (max !== '' && !isNaN(max)) map[f.max_param] = [String(max)];
    go(toUrl(map));
  }

  function clearAll() {
    var params = currentParams();
    var base = baseParams(params);
    Array.from(base.keys()).forEach(function (k) { if (k.indexOf('pick.') === 0) base.delete(k); });
    base.delete('color');
    base.delete('store');
    base.delete('stock');
    var map = {};
    map[P.avail] = ['1'];
    go(toUrl(map, base));
  }

  /* ---------- Fetch + swap ---------- */

  function go(url, opts) {
    opts = opts || {};
    if (!opts.pop) history.pushState({ trws: true }, '', url);
    load(url, false);
  }

  function load(url, append) {
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    if (!append) root.classList.add('is-loading');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('TrwsPlpResults');
        if (!fresh) { location.href = url; return; }
        if (append) {
          var grid = resultsEl.querySelector('.boxes-wrapper');
          var newGrid = fresh.querySelector('.boxes-wrapper');
          if (grid && newGrid) grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          initCards();
          checkStores();
          if (data.scan) {
            var fd = fresh.querySelector('#TrwsPlpData');
            try { var nd = JSON.parse(fd.textContent); data.count += nd.count || 0; data.more = nd.more; } catch (err) {}
            updateCounts();
          }
          var oldMore = resultsEl.querySelector('.trws-more');
          var newMore = fresh.querySelector('.trws-more');
          if (oldMore) oldMore.outerHTML = newMore ? newMore.outerHTML : '';
          updateCounts();
          fillSale();
          return;
        }
        resultsEl.innerHTML = fresh.innerHTML;
        fillSale.target = 0;
        readData();
        renderFilters();
        initCards();
        checkStores();
        fillSale();
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') location.href = url; })
      .then(function () { root.classList.remove('is-loading'); });
  }

  /* ---------- Events ---------- */

  function onChange(e) {
    var t = e.target;
    if (t.matches('input[data-store]')) {
      setStore(t.getAttribute('data-store'), t.checked);
    } else if (t.matches('input[data-color]')) {
      setColor(t.getAttribute('data-color'), t.checked);
    } else if (t.matches('input[data-pick]')) {
      togglePick(t.getAttribute('data-pick'), t.getAttribute('data-label'), t.checked);
    } else if (t.matches('input[data-param]')) {
      setValues(t.getAttribute('data-param'), JSON.parse(t.getAttribute('data-values')), t.checked);
    } else if (t.matches('input[data-toggle]')) {
      setToggle(t.getAttribute('data-toggle'), t.checked);
    } else if (t.matches('[data-trws-sort]')) {
      var params = currentParams();
      params.set('sort_by', t.value);
      params.delete('page');
      go(location.pathname + '?' + params.toString());
    }
  }

  function onClick(e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    if (t.matches('[data-chip-pick]')) {
      togglePick(t.getAttribute('data-chip-pick'), t.getAttribute('data-label'), false);
    } else if (t.matches('.trws-chip[data-param]')) {
      setValues(t.getAttribute('data-param'), JSON.parse(t.getAttribute('data-values')), false, true);
    } else if (t.matches('[data-chip-store]')) {
      setStore(t.getAttribute('data-chip-store'), false);
    } else if (t.matches('[data-chip-color]')) {
      setColor(t.getAttribute('data-chip-color'), false);
    } else if (t.matches('[data-chip-price]')) {
      setPrice('', '');
    } else if (t.matches('[data-chip-toggle]')) {
      setToggle(t.getAttribute('data-chip-toggle'), false);
    } else if (t.matches('[data-clear-all]')) {
      clearAll();
    } else if (t.matches('[data-price-go]')) {
      var box = t.closest('.trws-price');
      setPrice($('[data-price="min"]', box).value, $('[data-price="max"]', box).value);
    } else if (t.matches('[data-brands-toggle]')) {
      brandsOpen = !brandsOpen;
      var all = t.parentNode.querySelector('.trws-brands__all');
      all.hidden = !brandsOpen;
      t.setAttribute('aria-expanded', brandsOpen);
      t.textContent = brandsOpen ? 'Hide other brands' : t.textContent;
      if (!brandsOpen) renderFilters(); else { var fi = all.querySelector('[data-brand-find]'); if (fi && window.innerWidth > 989) fi.focus(); }
    } else if (t.matches('[data-more-btn]')) {
      t.closest('.trws-f__body').querySelectorAll('[data-more]').forEach(function (li) { li.hidden = false; });
      t.remove();
    } else if (t.matches('[data-load-more]')) {
      e.preventDefault();
      if (data.scan || storeOn()) fillSale.target = visibleCards() + SALE_TARGET;
      t.disabled = true;
      t.textContent = 'Loading...';
      load(withState(t.getAttribute('data-load-more')), true);
    } else if (t.matches('[data-trws-open]')) {
      openDrawer(true);
    } else if (t.matches('[data-trws-close]')) {
      openDrawer(false);
    }
  }

  function openDrawer(on) {
    root.classList.toggle('drawer-open', on);
    document.documentElement.classList.toggle('trws-lock', on);
    if (on) { var c = root.querySelector('.trws-plp__drawer-head button'); if (c) c.focus(); }
  }

  /* Cards: same slick setup as the live site (main image fades, color thumbs below, 3 at a time). */
  function initCards() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      if ((initCards.tries = (initCards.tries || 0) + 1) < 60) setTimeout(initCards, 100);
      else resultsEl.classList.add('trws-noslick');
      return;
    }
    resultsEl.querySelectorAll('.box.product-card').forEach(function (box) {
      if (box.getAttribute('data-slick-ready')) return;
      box.setAttribute('data-slick-ready', '1');
      var $for = $(box).find('.slider-for');
      var $nav = $(box).find('.slider-nav');
      $for.slick({ slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: true, asNavFor: $nav });
      $nav.slick({ slidesToShow: 3, slidesToScroll: 1, asNavFor: $for, dots: false, centerMode: false, focusOnSelect: true });
    });
  }

  /* In-store pickup. Liquid cannot see per-store stock on collection pages, so cards are checked
     with the Storefront API (variant storeAvailability) and hidden when nothing in the shopper's
     size (or any size) is on the shelf at the picked store. Needs the storefront app to have the
     "product pickup locations" scope; without it the store group stays hidden (storeApi = false). */
  var storeApi = null; // null = unknown, true = works, false = no access
  function storeOn() { return storeApi === true && pickedStores().length > 0; }
  function visibleCards() { return resultsEl.querySelectorAll('.product-card:not([data-store-hide])').length; }

  function sfQuery(query, variables) {
    return fetch('/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  var STORE_Q = 'query($ids:[ID!]!){nodes(ids:$ids){... on Product{id variants(first:250){nodes{selectedOptions{name value} storeAvailability(first:5){nodes{available location{id}}}}}}}}';

  function probeStores() {
    var card = resultsEl.querySelector('.product-card[data-product-id]');
    if (!card) { storeApi = false; return Promise.resolve(); }
    var cached = null;
    try { cached = sessionStorage.getItem('trwsStoreApi'); } catch (e) {}
    if (cached) { storeApi = cached === '1'; return Promise.resolve(); }
    return sfQuery(STORE_Q, { ids: ['gid://shopify/Product/' + card.getAttribute('data-product-id')] }).then(function (j) {
      storeApi = !(j.errors && j.errors.length);
      try { sessionStorage.setItem('trwsStoreApi', storeApi ? '1' : '0'); } catch (e) {}
    }).catch(function () { storeApi = false; });
  }

  function checkStores() {
    if (!storeOn()) {
      resultsEl.querySelectorAll('[data-store-hide]').forEach(function (c) { c.removeAttribute('data-store-hide'); c.hidden = false; });
      return;
    }
    var cards = Array.prototype.slice.call(resultsEl.querySelectorAll('.product-card:not([data-store-ok])'));
    if (!cards.length) return;
    var locs = pickedStores().map(function (id) { var st = STORES.filter(function (x) { return x.id === id; })[0]; return st && st.loc; }).filter(Boolean);
    var sizes = currentParams().getAll(P.size);
    var ids = cards.map(function (c) { return 'gid://shopify/Product/' + c.getAttribute('data-product-id'); });
    var batches = [];
    for (var i = 0; i < ids.length; i += 24) batches.push(ids.slice(i, i + 24));
    Promise.all(batches.map(function (b) { return sfQuery(STORE_Q, { ids: b }); })).then(function (results) {
      var ok = {};
      results.forEach(function (j) {
        ((j.data && j.data.nodes) || []).forEach(function (p) {
          if (!p) return;
          ok[p.id] = (p.variants.nodes || []).some(function (v) {
            if (sizes.length && !(v.selectedOptions || []).some(function (o) { return /size/i.test(o.name) && sizes.indexOf(o.value) > -1; })) return false;
            return (v.storeAvailability.nodes || []).some(function (sa) { return sa.available && locs.indexOf(sa.location.id) > -1; });
          });
        });
      });
      cards.forEach(function (c) {
        c.setAttribute('data-store-ok', '1');
        if (!ok['gid://shopify/Product/' + c.getAttribute('data-product-id')]) { c.setAttribute('data-store-hide', '1'); c.hidden = true; }
      });
      updateCounts();
      fillSale();
    });
  }

  // Shopify's paginate links drop params it does not know (color, view). Put them back.
  function withState(url) {
    var u = new URL(url, location.origin);
    var cur = currentParams();
    ['view', 'color', 'store'].forEach(function (k) {
      if (!u.searchParams.has(k)) cur.getAll(k).forEach(function (v) { u.searchParams.append(k, v); });
    });
    return u.pathname + '?' + u.searchParams.toString();
  }

  /* Scan views (sale, color) render in small chunks; keep pulling the next chunk until at least
     24 matches show (or the collection runs out). Shopper can still press Show more. */
  var SALE_TARGET = 24;
  function fillSale() {
    if (!data || !(data.scan || storeOn())) return;
    if (storeOn() && resultsEl.querySelector('.product-card:not([data-store-ok])')) return; // wait for the pickup check
    var btn = resultsEl.querySelector('[data-load-more]');
    var shown = visibleCards();
    if (btn && shown < (fillSale.target || SALE_TARGET)) {
      btn.disabled = true;
      btn.textContent = 'Finding more matches...';
      load(withState(btn.getAttribute('data-load-more')), true);
    } else {
      fillSale.target = shown + SALE_TARGET;
    }
  }

  /* Start (or restart) on the current #TrwsPlp. The preview's hot reload, the theme editor and
     some back/forward restores swap the section's HTML without re-running this file, which used
     to leave an empty sidebar. Each new #TrwsPlp is picked up and started once. */
  var docBound = false;
  function init() {
    var r = document.getElementById('TrwsPlp');
    if (!r || r.getAttribute('data-trws-ready')) return;
    r.setAttribute('data-trws-ready', '1');
    root = r;
    sectionId = root.getAttribute('data-section-id');
    saleMode = root.getAttribute('data-sale-mode') === 'true';
    isSearch = root.getAttribute('data-search') === 'true';
    filtersEl = document.getElementById('TrwsPlpFilters');
    chipsEl = document.getElementById('TrwsPlpChips');
    resultsEl = document.getElementById('TrwsPlpResults');
    readData();
    renderFilters();
    initCards();
    fillSale();
    probeStores().then(function () { renderFilters(); checkStores(); });
    root.addEventListener('change', onChange);
    root.addEventListener('click', onClick);
    root.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d && d.matches && d.matches('details[data-group]')) openGroups[d.getAttribute('data-group')] = d.open;
    }, true);
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-brand-find]')) findBrand(e.target);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-price]')) {
        var box = e.target.closest('.trws-price');
        setPrice($('[data-price="min"]', box).value, $('[data-price="max"]', box).value);
      }
    });
    // Safety net: if the sidebar is still empty a moment later, draw it again.
    setTimeout(function () { if (filtersEl && filtersEl.isConnected && !filtersEl.innerHTML.trim()) renderFilters(); }, 1500);

    if (docBound) return;
    docBound = true;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root) openDrawer(false); });
    window.addEventListener('popstate', function () { if (root && root.isConnected) load(location.pathname + location.search, false); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && filtersEl && !filtersEl.innerHTML.trim()) renderFilters();
    });
    document.addEventListener('shopify:section:load', init);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var nr = document.getElementById('TrwsPlp');
        if (nr && !nr.getAttribute('data-trws-ready')) init();
      }).observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
